import React from "react";
import { connect } from "react-redux";
import { Snackbar, IconButton, SnackbarContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { closeSnackbar } from "../../redux/actions/snackbar.actions";
import { Colors } from "../../utils/style/colors";

const variants = {
  error: Colors.danger,
  success: Colors.success,
};

const SnackbarComponent = ({
  isOpen,
  message,
  closeSnackbar,
  variant = "error",
}) => {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    closeSnackbar();
  };

  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <Snackbar
      open={isOpen}
      key={message}
      autoHideDuration={3000}
      onClose={handleClose}
      action={action}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <SnackbarContent
        style={{
          backgroundColor: variants[variant] || Colors.gray50,
        }}
        message={message}
        action={action}
      />
    </Snackbar>
  );
};

export default connect(
  (state) => ({
    message: state.snackbar.get("message"),
    isOpen: state.snackbar.get("isOpen"),
    variant: state.snackbar.get("variant"),
  }),
  {
    closeSnackbar,
  }
)(SnackbarComponent);
